import {
  Button,
  Drawer,
  message,
  Spin,
  Tabs,
  Tooltip,
  Input,
  Modal,
  Dropdown,
  Select,
  Collapse,
  Switch
} from "antd";
const { Panel } = Collapse;
const { Option } = Select;
import { connect } from "dva";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  createContext,
  useReducer,
  useRef
} from "react";
import { cloneDeep } from "lodash";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import IconFont from "@/components/icon";
import { ICreateSuperviseData } from "@/types/supervise";
import GlobalContext from "@/context/GlobalContext";
import { getTaskDetail, modifyWholeTask } from "@/api/work";
import {
  findSelfInExecutors,
  findIndexExecutorInTask,
  getDefaultStartTime,
  getDefaultStopTime
} from "../utils";
import "./index.less";
import {
  NewTaskModel,
  PRIORITY_TYPE,
  PROCESS_STATUS,
  TaskListParams,
  TaskListByTaskGroupParams,
  TaskResource,
  TASK_STATUS,
  RemarkInfo,
  WorkUserInfo,
  taskGroupsInfo
} from "@/types/newWork";
import { decorateTaskDetail, judgeTaskFinishOrStop } from "../newUtils";
import { nanoid } from "nanoid";
import { getFileIconByMime } from "@/utils/chat/index";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import bus from "@/utils/bus";
import {
  TaskPartEnum,
  TimeClassifyEnum,
  TaskResourceBizType,
  TaskResourcePermissionType,
  GroupMessagePart
} from "@/types/work";
import CryptoJS from "crypto-js";
import syncConfirm from "@/utils/syncConfirm";
import ScrollView from "@/baseComponents/ScrollView";
const FORCE_GET = "1cf07dd502458e65675172405c2dc3db";

import { openUserSelectionDefaultModal } from "@/utils/modals";
import config, { ConfigEnum } from "@/config/config";
import lodashCompact from "lodash/compact";
import prompt from "@/baseComponents/ModalComponent/prompt";
import TypeSelect from "../BaseComponents/TypeSelect";
import DatePicker from "@/components/Calendars/BaseComponents/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { remindList } from "../CreateTaskDraw/index";
import { htmlUnescape } from "@/utils/tools";
import AttachmentItem from "@/components/AttachmentComp/attachmentItem";
import { ContactShowType } from "@jd/focus-desktop-comps/lib/es/UserSelection/types";
import { BusinessForm } from "@/utils/chat/message";
import { userSelectionTabSort } from "@/types/common";
import TaskGroupModal from "../BaseComponents/TaskGroupModal";
import { MemberKeys } from "@/models/work";
import UserStatusListPopover from "@/baseComponents/UserStatusListPopover";
import UserListMore, { UserItem } from "@/baseComponents/UserListMore";

enum FileStatus {
  Init = 1,
  Uploading,
  Done,
  failed
}
interface IState {
  fileList: any[];
}
const initialState: IState = {
  fileList: []
};
function reducer(state: IState, action: any) {
  const { payload } = action;
  switch (action.type) {
    case "changeState":
      return { ...state, ...payload };
    case "reloadAttchment": // 多端同步时，处理一下正在上传的文档
      // eslint-disable-next-line no-case-declarations
      const fileList: any[] = state.fileList.filter(
        (file: any) => file.status === FileStatus.Uploading
      );
      payload.list.forEach((l: any) => {
        fileList.push({
          fileName: l.name,
          size: l.size,
          fileType: l.fileType,
          fileId: l.bizId || nanoid(20),
          fileUrl: l.url,
          percent: 0,
          status: FileStatus.Done,
          resourceId: l.resourceId,
          icon: getFileIconByMime(l.fileType),
          creatorUserId: l?.creatorUserId
        });
      });
      return { ...state, fileList };
    default:
      throw new Error("未知错误");
  }
}
export const TaskDetailContext = createContext<{
  taskDetail: NewTaskModel;
  setTaskDetail: any;
  closeDrawAndRefresh: Function;
}>({} as any);

let clicksign = false; // 记录是不是点击 label里的 ‘+ 添加附件’
// eslint-disable-next-line complexity
function TaskDetailDrawEdit({
  userData,
  drawEditVisible,
  taskId,
  taskDetail0,
  forceGet,
  detailStateActiveTab,
  changeEditTaskDraw,
  openCreateSuperviseModal,
  getTasks,
  offset,
  offsets,
  processStatuses,
  taskStatuses,
  priorityTypes,
  userRole,
  fieldSortType,
  taskGroupList,
  getTasksByTaskGroup,
  fetchTaskGroupsList,
  groupId,
  activeKey,
  currentEmployee
}: {
  drawEditVisible: boolean;
  userData: any;
  taskId: string;
  taskDetail0: NewTaskModel | null | undefined;
  forceGet: boolean;
  detailStateActiveTab: string;
  openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => void;
  changeEditTaskDraw: (taskId: string, visible: boolean) => void;
  getTasks: (params: TaskListParams) => void;
  getTasksByTaskGroup: (params: TaskListByTaskGroupParams) => void;
  fetchTaskGroupsList: () => void;
  offset: number;
  offsets: number[];
  processStatuses: PROCESS_STATUS[];
  taskStatuses: TASK_STATUS[];
  priorityTypes: PRIORITY_TYPE[];
  userRole: number;
  fieldSortType: number;
  taskGroupList: any[];
  groupId: string;
  activeKey: string;
  currentEmployee: any;
}) {
  if (taskDetail0 && !taskDetail0.resources) {
    taskDetail0.resources = [];
  }
  const location = useLocation();
  const { t } = useTranslation("work");
  const [t_common] = useTranslation("common");
  const [t_chat] = useTranslation("chat");
  const { authInfo } = useContext(GlobalContext);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [taskDetail, setTaskDetail] = useState<NewTaskModel | null | undefined>(taskDetail0);
  const [taskDetailDouble, setTaskDetailDouble] = useState<NewTaskModel | null>(null);
  const { accessToken } = authInfo;
  const [submitting, setSubmitting] = useState(false);
  const scrollRef = useRef(null);
  const [remindArr, setRemindArr] = useState<string[]>(
    taskDetail?.remind ? taskDetail.remind.split(",") : []
  );
  const [newFileList, setNewFileList] = useState<any>(taskDetail?.resources || []);

  const [attachmentMenuShowFn, setAttachmentMenuShowFn] = useState<Function>(() => () => {});
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    const resetGroupId = (data: any) => {
      if (!drawEditVisible) {
        return;
      }
      if (
        data.part === GroupMessagePart.TASK_GROUP_REMOVE ||
        data.part === GroupMessagePart.TASK_GROUP_REMOVE_USER
      ) {
        message.info({
          content: "任务分组权限发生变更",
          key: "task-group-permission-changed"
        });
        setTaskDetail((prev) => {
          if (!prev) {
            return null;
          }
          return {
            ...prev,
            taskGroups: prev.taskGroups?.filter((i) => i.groupId !== data.taskGroupId),
            taskGroupIds: prev.taskGroupIds?.filter((i) => i !== data.taskGroupId)
          };
        });
      }
    };

    // 分组数据更新，重置已选择的分组
    bus.on("joywork:refresh-group", resetGroupId);

    return () => {
      bus.off("joywork:refresh-group", resetGroupId);
    };
  }, [drawEditVisible]);

  useEffect(() => {
    changeEditTaskDraw("", false);
  }, [changeEditTaskDraw, location]);
  useEffect(() => {
    setNewFileList(() => {
      taskDetail?.resources?.forEach((item) => {
        item.bizId = item.bizId || nanoid(20);
      });
      return taskDetail?.resources || [];
    });
    setRemindArr(taskDetail?.remind ? taskDetail.remind.split(",") : []);
    // 如果详情中存在任务分组且该分组被删除或者被取消共享taskGroupList则不包含，显示会产生问题
    // 在taskGroups中没在taskGroupList中 需添加到taskGroupList中显示 且不可被选择
    if (taskDetail?.taskGroups?.length) {
      taskDetail?.taskGroups?.forEach((item: taskGroupsInfo) => {
        const indexGroup = taskGroupList?.findIndex((g) => g.groupId === item.groupId);
        if (indexGroup < 0) {
          taskGroupList?.push({
            groupId: item.groupId,
            groupName: item.groupName,
            noShow: true
          });
        }
      });
    }
  }, [taskDetail, taskGroupList]);

  /**
   * 初始化数据
   */
  useEffect(() => {
    if (!taskId) {
      setTaskDetail(null);
      return;
    }
    if (!drawEditVisible) {
      return;
    }

    let share = "";
    if (forceGet) {
      share = CryptoJS.AES.encrypt(`share:${accessToken}`, CryptoJS.enc.Utf8.parse(FORCE_GET), {
        iv: CryptoJS.enc.Utf8.parse("0102030405060708"),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
    }
    if (taskDetail0) {
      setTaskDetailDouble(cloneDeep(taskDetail0) as NewTaskModel);
      setTaskDetail(taskDetail0);
      if (taskDetail0.processStatus === PROCESS_STATUS.NOT_VIEWED) {
        setTaskDetail({ ...taskDetail0, processStatus: PROCESS_STATUS.PUSHING });
      }
      return;
    }
    getTaskDetail(taskId, share).then(([result, err]) => {
      if (err || !result) {
        console.error("get task err:", err);
        message.warn(err as string);
        changeEditTaskDraw("", false);
        return;
      }
      const task = decorateTaskDetail(result as NewTaskModel);

      setTaskDetailDouble(cloneDeep(task) as NewTaskModel);
      setTaskDetail(task);
      initFileList(task.resources);
      if (task.processStatus === PROCESS_STATUS.NOT_VIEWED) {
        setTaskDetail({ ...task, processStatus: PROCESS_STATUS.PUSHING });
      }
    });
  }, [
    taskId,
    taskDetail0,
    drawEditVisible,
    changeEditTaskDraw,
    detailStateActiveTab,
    forceGet,
    accessToken
  ]); // eslint-disable-line react-hooks/exhaustive-deps
  /**
   * 监听多端同步
   * 单独处理一下正在上传的附件
   * TODO: 需要根据实际情况处理
   */
  useEffect(() => {
    function reloadDetail(msg: any) {
      const { data } = msg;
      if (!data) {
        console.error("------->多端同步消息错误", msg);
        return;
      }
      const { timeclassify, part } = data;
      if (!taskId) {
        setTaskDetail(null);
        return;
      }
      if (!drawEditVisible) {
        return;
      }
      if (
        ![
          TaskPartEnum.PERSONAL_TASK,
          TaskPartEnum.MEANWHILE_TASK,
          TaskPartEnum.PROJECT_TASK
        ].includes(part)
      ) {
        return;
      }
      if (taskId !== data.taskId && Number(timeclassify) !== 999) {
        return;
      }

      let share = "";
      if (forceGet) {
        share = CryptoJS.AES.encrypt(`share:${accessToken}`, CryptoJS.enc.Utf8.parse(FORCE_GET), {
          iv: CryptoJS.enc.Utf8.parse("0102030405060708"),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).toString();
      }

      getTaskDetail(taskId, share).then(([result, err]) => {
        if (err || !result) {
          console.error("get task err:", err);
          message.warn(err as string);
          changeEditTaskDraw("", false);
          return;
        }
        const task = decorateTaskDetail(result as NewTaskModel);
        setTaskDetail(task);
        dispatch({
          type: "reloadAttchment",
          payload: {
            list: task.resources
          }
        });
      });
    }
    function handleNetworkChange(data: any) {
      const { connectState } = data;
      if (connectState.state === ConnectState.READY) {
        reloadDetail({ data: { taskId } });
      }
    }
    bus.on("chat_message_multiSync_event:joyWork", reloadDetail);
    bus.on("chat:connect_state_change", handleNetworkChange);
    return () => {
      bus.off("chat_message_multiSync_event:joyWork", reloadDetail);
      bus.off("chat:connect_state_change", handleNetworkChange);
    };
  }, [taskId, drawEditVisible, changeEditTaskDraw, forceGet, accessToken]);

  function initFileList(list: TaskResource[]) {
    const fileList = list.map((l) => {
      return {
        fileName: l.name,
        size: l.size,
        fileType: l.fileType,
        fileId: l.bizId || nanoid(20),
        fileUrl: l.url,
        percent: 0,
        status: FileStatus.Done,
        resourceId: l.resourceId,
        icon: getFileIconByMime(l.fileType),
        creatorUserId: l?.creatorUserId
      };
    });
    dispatch({
      type: "changeState",
      payload: {
        fileList
      }
    });
  }
  const isPrimaryHead = !!(
    (taskDetail0?.owner && findSelfInExecutors([taskDetail0?.owner], userData)) ||
    (taskDetail0?.creator && findSelfInExecutors([taskDetail0?.creator], userData))
  );
  const [isHead, self, isOwnerOrExecutor, isSubscribers] = useMemo(() => {
    if (!taskDetail) {
      return [false, null, false];
    }
    let isHead = false;
    let self = null;
    let isOwnerOrExecutor = false;
    let isSubscribers = false;
    const ownerHeader = findSelfInExecutors([taskDetail.owner], userData);
    const creatorHeader = findSelfInExecutors(
      taskDetail.creator ? [taskDetail.creator] : [],
      userData
    );
    if (ownerHeader || creatorHeader) {
      isHead = true;
    }
    self = findSelfInExecutors(taskDetail.executors, userData);
    if (ownerHeader || self) {
      isOwnerOrExecutor = true;
    }
    const subHeader = findSelfInExecutors(taskDetail.subscribers, userData);
    if (subHeader) {
      isSubscribers = true;
    }
    return [isHead, self, isOwnerOrExecutor, isSubscribers];
  }, [taskDetail, userData]);

  const isTaskFinishOrStop = useMemo(() => {
    if (!taskDetail) {
      return false;
    }
    let isTaskFinishOrStop = false;
    if (judgeTaskFinishOrStop(taskDetail.taskStatus)) {
      isTaskFinishOrStop = true;
    }
    return isTaskFinishOrStop;
  }, [taskDetail]);

  const closeDraw = useCallback(() => {
    setTaskDetail(null);
    changeEditTaskDraw(taskId, false);
  }, [changeEditTaskDraw, taskId]);

  function closeDrawConfirm() {
    function cancleAtt(status: boolean) {
      bus.off("cancle-attachment-upload", cancleAtt);

      // if (status) {
      //     message.warning(t('attachment uploading'));
      //     return;
      // } else {
      try {
        // 判断是否有编辑内容
        if (JSON.stringify(taskDetailDouble) !== JSON.stringify(taskDetail) || status) {
          Modal.confirm({
            content: <span className="nimble-con">{t("tip content")}</span>,
            transitionName: "notransition",
            maskTransitionName: "notransition",
            okText: t("confirm"),
            cancelText: t("cancel"),
            onOk() {
              closeDraw();
              status && bus.emit("close-modal-with-cancle-attachment-upload");
              // document
              //     .getElementsByClassName('ant-modal-root')[0]
              //     ?.setAttribute('id', 'confirmmodal');
              // const ele = document.getElementById('confirmmodal');
              // if (ele) ele.style.display = 'none';
            }
          });
        } else {
          closeDraw();
        }
      } catch (error) {
        closeDraw();
      }
      // }
    }
    bus.on("cancle-attachment-upload", cancleAtt);

    bus.emit("close-modal-detail");

    return () => {
      bus.off("cancle-attachment-upload", cancleAtt);
    };
  }

  const getTaskList = useCallback(() => {
    if (activeKey === "task_group") {
      getTasksByTaskGroup({
        groupId,
        fieldSortType,
        taskStatuses,
        priorityTypes,
        limit: offsets ? offsets.length * 20 : 20,
        offset: 0
      });
      bus.emit("task:taskgroup_statistical");
    } else {
      getTasks({
        limit: offsets ? offsets.length * 20 : 20,
        offset: 0,
        // offsets: offsets,
        processStatuses: processStatuses,
        taskStatuses: taskStatuses,
        priorityTypes: priorityTypes,
        userRole: userRole,
        fieldSortType
      });
    }
  }, [
    activeKey,
    getTasksByTaskGroup,
    groupId,
    fieldSortType,
    priorityTypes,
    offsets,
    getTasks,
    processStatuses,
    taskStatuses,
    userRole
  ]);

  const closeDrawAndRefresh = useCallback(
    (cb: Function = function () {}) => {
      setTaskDetail(null);
      changeEditTaskDraw(taskId, false);
      cb();
    },
    [changeEditTaskDraw, taskId]
  );

  const handleModifyDetailInfo = useCallback(async () => {
    const data: any = taskDetail;
    if (!data) {
      return;
    }
    // 不允许跨租户、跨平台人员创建日程
    // 由于任务禁止选择外部人员 只需判断当前用户是否是外部人员且在任务创建人或协同人中则不允许创建
    // owner executors currentEmployee
    const hasOuterExecutor = data.executors?.findIndex(
      (executor: WorkUserInfo) =>
        executor.app === currentEmployee.app &&
        executor.userId === currentEmployee.userId &&
        executor.teamId === currentEmployee.teamId
    );
    if (
      (hasOuterExecutor > -1 ||
        (data.owner.app === currentEmployee.app &&
          data.owner.userId === currentEmployee.userId &&
          data.owner.teamId === currentEmployee.teamId)) &&
      (currentEmployee.userType === "4" || currentEmployee.userType === "5")
    ) {
      return message.error(t("External users do not support using tasks"));
    }
    if (!data?.title) {
      message.error(t("create task err title"));
      return;
    }
    if (data.workStartTime && dayjs().isAfter(data.workStartTime)) {
      const confirm = await syncConfirm("是否编辑一个过去时间的任务");
      if (!confirm) {
        return;
      }
    }
    setSubmitting(true);
    const [result, err] = await modifyWholeTask({
      ...(data || {}),
      taskGroupIds:
        data.taskGroupIds || data?.taskGroups?.map((task: { groupId: any }) => task.groupId) || [],
      multiTaskGroup: true
    });
    if (err) {
      message.warn(err as string);
      setSubmitting(false);
      fetchTaskGroupsList();
      setTaskDetail((prev) => {
        return { ...prev, taskGroupIds: taskDetail0?.taskGroupIds } as any;
      });
      return false;
    }
    const task = decorateTaskDetail(result as NewTaskModel);
    setTaskDetail(task);
    message.success(t("save success"));
    // console.log("handleModifyDetailInfo==>>", groupId);
    setSubmitting(false);
    closeDrawAndRefresh(() => {
      if (location.pathname?.indexOf("/calendar") > -1) {
        bus.emit("calendar:reloadSchedule");
      } else {
        fetchTaskGroupsList();
        getTaskList();
      }
    });
  }, [
    taskDetail,
    currentEmployee.app,
    currentEmployee.userId,
    currentEmployee.teamId,
    currentEmployee.userType,
    t,
    closeDrawAndRefresh,
    location.pathname,
    fetchTaskGroupsList,
    getTaskList
  ]);

  /* yixia-任务内容-或许可以封为组件  */
  const modifyValidate = useCallback(() => {
    function cancleAtt(status: boolean) {
      bus.off("cancle-attachment-upload", cancleAtt);
      if (status) {
        message.warning(t("attachment uploading"));
        return;
      } else {
        handleModifyDetailInfo();
      }
    }
    bus.on("cancle-attachment-upload", cancleAtt);
    bus.emit("close-modal-detail");
    return () => {
      bus.off("cancle-attachment-upload", cancleAtt);
    };
  }, [handleModifyDetailInfo, t]);
  const handleUpdateOwner = useCallback(() => {
    const { userId, teamUserInfo } = userData;
    const { ddAppId, teamId } = teamUserInfo;
    openUserSelectionDefaultModal(
      {
        title: t_chat("add_member"),
        // tabs: ['recommend', 'org'],
        tabs: !config[ConfigEnum.EXTERNAL_CONTACTS_ORG]
          ? ["recent", "workLine", "externalContacts", "group"]
          : ["recent", "org", "workLine", "externalContacts", "group"],
        tabSort: userSelectionTabSort,
        single: true,
        resultUsers: lodashCompact([taskDetail?.owner]).map((item) => ({
          id: item.userId + ":" + item.app + ":" + item.teamId,
          name: item.realName,
          avatar: item.headImg,
          userId: item.userId,
          teamId: item.teamId,
          checked: true,
          visible: false
        })),
        recommendParam: {
          keyWords: taskDetail?.title || "",
          aiType: ["empl"]
        },
        contactShowType: ContactShowType.sameTenement,
        // contactsFilterFlag: ["crossPlatform", "sameTeam", "crossTeam"],
        currentUser: {
          app: ddAppId,
          pin: userId,
          teamId: teamId
        }
      },
      (data, close) => {
        // 过滤掉已选中的
        const { result } = data.data;
        if (!result.length) {
          return close();
        }
        if (!taskDetail) {
          return;
        }
        const addArr: any[] = [];
        result.forEach((r) => {
          if (r.id) {
            const strs = r.id.split(":");
            return addArr.push({
              userId: strs[0],
              teamId: strs[2],
              app: strs[1],
              headImg: r.avatar,
              realName: r.name
            });
          }
          const { origin } = r;
          if (origin.info) {
            addArr.push({
              userId: origin.info.userId,
              teamId: origin.info.teamId,
              app: origin.info.appId || origin.info.app
            });
          } else {
            addArr.push({
              userId: origin.userId,
              teamId: origin.teamId,
              app: origin.app
            });
          }
        });
        prompt({
          title: t(
            `${!taskDetail.owner ? "Set the person in charge" : "Person in charge of transfer"}`
          ),
          icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
          onOk: async () => {
            if (!taskDetail) {
              return;
            }

            setTaskDetail({ ...taskDetail, owner: addArr[0] });
          },
          content: t("transfer owner desc").replace("%s", addArr[0].realName),
          okText: t_common("button.ok"),
          cancelText: t_common("button.cancel")
        });
        close();
      },
      userData
    );
  }, [t, t_chat, t_common, taskDetail, userData]);

  const disabled = useMemo(() => {
    return isTaskFinishOrStop || !(isPrimaryHead || self) ? true : false;
  }, [isTaskFinishOrStop, isPrimaryHead, self]);
  const [textareaContentFocus, setTextareaContentFocus] = useState<boolean>(false);
  const [textareaRemarkFocus, setTextareaRemarkFocus] = useState<boolean>(false);
  // 只有负责人有编辑描述权限 1.5.0
  const descIsEdit = useMemo(() => {
    return !isTaskFinishOrStop && isHead ? true : false;
  }, [isTaskFinishOrStop, isHead]);

  async function handleTaskMembersWeight(data: any[]) {
    if (!taskDetail) {
      return;
    }
    setTaskDetail({ ...taskDetail, executors: [...data] });
  }
  async function handleAddTaskMembers(key: MemberKeys, data: any[]) {
    if (!taskDetail) {
      return;
    }
    const temp: any[] = [];
    const members = [...taskDetail[key]];
    data.forEach((m: any) => {
      const index = findIndexExecutorInTask(members, m);
      if (index === -1) {
        temp.push({ ...m, processStatus: 4 }); // 刚添加的协同人默认显示未查看
      } else {
        members[index].weight = m.weight; // 更新原有人的权重
      }
    });
    if (temp.length === 0) {
      return;
    }
    if ([...members, ...temp]?.length > 200) {
      message.warn(t("200 person limit"));
      return;
    }
    setTaskDetail({ ...taskDetail, [key]: [...members, ...temp] });
  }
  async function handledelMember(key: MemberKeys, data: any[]) {
    if (!taskDetail) {
      return;
    }
    const index = findIndexExecutorInTask(taskDetail[key], data[0]);
    if (index > -1) {
      const temp = taskDetail[key];
      temp.splice(index, 1);
      setTaskDetail({ ...taskDetail, [key]: temp });
    }
  }
  async function handlePriorityChange(priority: number) {
    if (!taskDetail) {
      return;
    }
    if (taskDetail.priorityType === priority) {
      return;
    }
    setTaskDetail({ ...taskDetail, priorityType: priority });
  }
  async function handleTimeChange(time: Dayjs | null, start = true) {
    if (!taskDetail) {
      return;
    }
    const unix = time ? time.valueOf() : null;
    if (start) {
      if (!unix || unix === taskDetail.startTime) {
        return;
      }
      let timeObj: any = {
        startTime: unix,
        workStartTime: dayjs(unix)
      };
      if (
        taskDetail.workStopTime &&
        dayjs(unix)?.add(30, "minute").isAfter(taskDetail.workStopTime)
      ) {
        timeObj = {
          ...timeObj,
          endTime: dayjs(unix)?.add(30, "minute").valueOf(),
          workStopTime: dayjs(unix)?.add(30, "minute")
        };
      }
      setTaskDetail({
        ...taskDetail,
        ...timeObj
      });
    } else {
      if (!unix || unix === taskDetail.endTime) {
        if (!unix) {
          setRemindArr([]);
        }
        return;
      }
      if (
        taskDetail.workStopTime &&
        taskDetail.workStartTime &&
        dayjs(unix).isBefore(taskDetail.workStartTime.add(30, "minute"), "minute")
      ) {
        return message.warn(t("deadline is at least 30 minutes later than the start time"));
      }
      const etime: Dayjs =
        !taskDetail.workStopTime &&
        taskDetail.workStartTime &&
        dayjs(unix).isBefore(taskDetail.workStartTime.add(30, "minute"), "minute")
          ? taskDetail.workStartTime.add(30, "minute")
          : dayjs(unix);
      const task = {
        ...taskDetail,
        endTime: etime.valueOf(),
        workStopTime: etime
      };
      setTaskDetail(task);
    }
  }
  async function handleInputChange(e: any, key: string, notInput?: boolean) {
    if (!taskDetail) {
      return;
    }
    let value = notInput ? e : e.target.value;
    // 多行文本输入的时候，如果是拼音，输入的时候，不按空格或选择，点击空白，拼音会上屏，这里只有备注和任务描述是textarea
    if (value.length > 500) {
      value = value.slice(0, 500);
    }
    if (key === "remark") {
      value = {
        id: (taskDetail.remark as RemarkInfo).id,
        remark: value
      };
    }
    const task = {
      ...taskDetail,
      [`${key}`]: value
    };
    setTaskDetail(task);
  }

  function onAttachmentRemove(fileId: string) {
    if (!taskDetail) {
      return;
    }
    const index = taskDetail.resources.findIndex((item) => item.bizId === fileId);
    if (index < -1) {
      return;
    }
    const temp = taskDetail.resources.map((item) => {
      return {
        ...item,
        fileName: item.name,
        fileId: item.bizId || nanoid(20),
        fileUrl: item.url,
        status: FileStatus.Done
      };
    });
    temp.splice(index, 1);

    setNewFileList(temp as any);
    setTaskDetail({ ...taskDetail, resources: temp });
  }

  async function onAttachmentUploadFinish(file: any) {
    if (!taskDetail) {
      return;
    }
    const resources = taskDetail.resources;
    if (Array.isArray(file)) {
      const files = file;
      const NewResource = files.map((f) => {
        return {
          ...f,
          name: f.fileName,
          size: f.size,
          url: f.fileUrl,
          resourceId: nanoid(),
          bizId: f.fileId,
          bizType: f.bizType || TaskResourceBizType.FILE,
          resourceType: TaskResourcePermissionType.COMMON,
          fileType: f.fileType,
          creatorUserId: f?.creatorUserId,
          isRemove: true,
          fileName: f.fileName,
          fileId: f.bizId || nanoid(20),
          fileUrl: f.url,
          status: FileStatus.Done
        };
      });
      resources.push(...NewResource);
      resources.forEach((item) => {
        Object.assign(item, {
          fileName: item.name,
          fileId: item.bizId || nanoid(20),
          fileUrl: item.url,
          status: FileStatus.Done
        });
      });
      setNewFileList(resources as any);
      setTaskDetail({ ...taskDetail, resources });
    } else {
      const NewResource = {
        resourceId: nanoid(),
        name: file.fileName,
        size: file.size,
        url: file.fileUrl,
        bizId: file.fileId,
        bizType: file.bizType || TaskResourceBizType.FILE,
        resourceType: TaskResourcePermissionType.COMMON,
        fileType: file.fileType,
        creatorUserId: file?.creatorUserId,
        isRemove: true,
        fileName: file.fileName,
        fileId: file.bizId || nanoid(20),
        fileUrl: file.url,
        status: FileStatus.Done
      };

      resources.push(NewResource);
      resources.forEach((item) => {
        Object.assign(item, {
          fileName: item.name,
          fileId: item.bizId || nanoid(20),
          fileUrl: item.url,
          status: FileStatus.Done
        });
      });

      setNewFileList(resources as any);
      setTaskDetail({ ...taskDetail, resources });
    }
    window.console.log("nnnddd-----:", resources.length);
  }

  const handleList = useCallback(
    (data) => {
      const setData = data?.map((item: any) => {
        return {
          ...item,
          canRemove: !isTaskFinishOrStop && (isHead || !!self)
        };
      });
      return setData;
    },
    [isTaskFinishOrStop, isHead, self]
  );
  const onVisibleChange = (visable: boolean) => {
    if (visable) {
      // 显示的时候，高低太低会使时间选择框错位，手动向下滚动一下
      const detailElement: HTMLElement | null = document.querySelector(".detail-content");
      if (detailElement && detailElement.offsetHeight + detailElement.scrollTop < 710) {
        detailElement.scrollTo(0, 710 - detailElement.offsetHeight);
      }
    }
  };
  const handleTaskReminChange = function (val: string[]) {
    if (val.length === 2 && val[0] === "0") {
      val.shift();
    }
    if (val.length >= 1 && val[val.length - 1] === "0") {
      setTaskDetail({
        ...(taskDetail as NewTaskModel),
        remind: "0"
      });
      setRemindArr(["0"]);
    } else {
      setTaskDetail({
        ...(taskDetail as NewTaskModel),
        remind: val.join(",")
      });
      setRemindArr([...val]);
    }
  };
  const operators = useMemo(() => {
    if (!taskDetail?.executors) {
      return [];
    }
    const newTaskDetail: any = taskDetail;
    if (newTaskDetail.executors.length > 3) {
      return taskDetail.executors.slice(0, 2);
    }
    return [...newTaskDetail.executors];
  }, [taskDetail]);

  const subscribers = useMemo(() => {
    if (!taskDetail?.subscribers) {
      return [];
    }
    const newTaskDetail: any = taskDetail;
    if (newTaskDetail.subscribers.length > 5) {
      return taskDetail.subscribers.slice(0, 4);
    }
    return [...newTaskDetail.subscribers];
  }, [taskDetail]);

  const createTaskgroup = () => {
    setIsModalVisible(true);
  };

  const DrawerFooter = (
    <div>
      <Button
        type="primary"
        clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_edit_sure"
        loading={submitting}
        // style={{ margin: "0 8px" }}
        onClick={modifyValidate}
      >
        {t("confirm")}
      </Button>
      <Button
        clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_edit_cancel"
        onClick={closeDrawConfirm}
      >
        取 消
      </Button>
    </div>
  );

  if (!drawEditVisible) {
    return null;
  }

  // console.log("taskDetail.taskGroupIds===>>", taskDetail?.taskGroupIds);
  return (
    <Drawer
      width={450}
      placement="right"
      title={
        <div className="detail-header">
          <div>{t("task edit detail")}</div>
          <div className="header-btn-wrapper">
            <div className="action-close action-button app-region-none" onClick={closeDrawConfirm}>
              <IconFont type="iconapp_btn_file_cancel" />
            </div>
          </div>
        </div>
      }
      keyboard={false}
      closable={false}
      onClose={closeDrawConfirm}
      className="work-edit-draw"
      visible={drawEditVisible}
      destroyOnClose={true}
      footer={DrawerFooter}
    >
      {!taskDetail ? (
        <div className="draw-loading">
          <Spin />
        </div>
      ) : (
        <>
          <ScrollView ref={scrollRef} autoHide>
            <div className="detail-content">
              <div className="content-part-top">
                <div className="detail-content-item task-title-item">
                  <div className="title-container">
                    {!isTaskFinishOrStop && isPrimaryHead ? (
                      <Input.TextArea
                        className="cursor-outline"
                        style={{ resize: "none" }}
                        autoSize={{ minRows: 1 }}
                        placeholder={t("input task content")}
                        defaultValue={htmlUnescape(taskDetail.title)}
                        onChange={(e) =>
                          setTaskDetail({
                            ...taskDetail,
                            title: e.target.value
                          })
                        }
                        maxLength={100}
                      />
                    ) : (
                      <div className="title-wrapper">
                        <Tooltip placement="bottom" arrowPointAtCenter title={taskDetail?.title}>
                          <span
                            style={{ display: "inline-block", padding: "16px 0" }}
                            className="title-wrapper-title"
                          >
                            {taskDetail?.title}
                          </span>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </div>
                <div className="detail-content-item task-textarea-item" style={{ marginTop: 0 }}>
                  {/* <div className="label" style={{ alignSelf: "flex-start" }}>
                    {t("task description")}
                  </div> */}
                  <div
                    className={`textarea-container ${
                      textareaContentFocus && (descIsEdit || isPrimaryHead)
                        ? "textarea-container-focus"
                        : ""
                    }`}
                  >
                    <Input.TextArea
                      className="cursor-outline"
                      placeholder={t("add description")}
                      autoSize
                      disabled={!descIsEdit && !isPrimaryHead}
                      defaultValue={htmlUnescape(taskDetail.content || "")}
                      onChange={(e) => handleInputChange(e, "content")}
                      onFocus={() => setTextareaContentFocus(true)}
                      onBlur={() => setTextareaContentFocus(false)}
                      maxLength={500}
                    />
                    {/* {taskDetail.content && taskDetail.content.length > 40 && (
                      <p className="content-length">
                        <span>{taskDetail.content?.length || 0}</span>/500
                      </p>
                    )} */}
                  </div>
                </div>
                {/* <div className="detail-content-type">{t('members info')}</div> */}
                <div className="detail-content-item task-owner-item">
                  <div className="label">{t("task user")}</div>
                  <div className="owner-container owner-user">
                    <UserListMore
                      disable={taskDetail0?.owner}
                      list={[taskDetail.owner]}
                      maxLength={8}
                      isShowName={true}
                      notAvatar={true}
                      notTooltip={true}
                      addMemberCb={handleUpdateOwner}
                      title={taskDetail.title}
                      isOnClick={isPrimaryHead && true}
                      taskUserRole={1}
                    />
                    {taskDetail.owner && (
                      <div
                        className="trans-owner"
                        onClick={isPrimaryHead ? handleUpdateOwner : undefined}
                      >
                        <span>负责</span>
                        {/* <IconFont type="iconlog_enter" className="icon-more" /> */}
                      </div>
                    )}
                  </div>
                  <span className="work-line" />
                  <div
                    className="owner-container"
                    clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_transferowner"
                  >
                    <UserStatusListPopover
                      popoverName="getTaskContent"
                      list={handleList(taskDetail.executors)}
                      onRemove={(data: any[]) => handledelMember(MemberKeys.executors, data)}
                      disable={disabled}
                      isHead={isHead}
                      isQueryAuditList={isOwnerOrExecutor}
                      userPopover="task"
                      userPopoverText="colaborator"
                      userData={userData}
                      taskDetail={taskDetail}
                      mode="edit"
                      visibleWeight={true}
                      showAdvance={false}
                      handleTaskMembersWeight={handleTaskMembersWeight}
                      isTaskRelatedPersonnel={!!(isHead || self || isSubscribers)}
                    >
                      <div className="owner-container-name">
                        {operators?.map((l, index) => (
                          <UserItem
                            key={"executor-" + index}
                            item={l}
                            notAvatar={true}
                            notTooltip={true}
                          />
                        ))}
                      </div>
                    </UserStatusListPopover>
                    <UserListMore
                      list={handleList(taskDetail.executors)}
                      maxLength={3}
                      isShowName={true}
                      hasWeightSet={true}
                      notAvatar={true}
                      title={taskDetail.title}
                      isOwner={isHead}
                      disable={disabled || taskDetail.executors.length >= 200}
                      handleAddTaskMembers={(data: any[]) =>
                        handleAddTaskMembers(MemberKeys.executors, data)
                      }
                      userPopover="task"
                      userPopoverText="colaborator"
                      mode="edit"
                      showUserItem={false}
                      taskUserRole={2}
                    />
                  </div>
                </div>
                <div
                  className="detail-content-item task-subscribers-item"
                  style={{ marginTop: "16px" }}
                >
                  <div className="label">{t("task subscribers")}</div>
                  <div className="subscribers-container">
                    <UserStatusListPopover
                      popoverName="getTaskContent"
                      list={handleList(taskDetail.subscribers)}
                      onRemove={(data: any[]) => handledelMember(MemberKeys.subscribers, data)}
                      disable={disabled}
                      isHead={isPrimaryHead}
                      taskDetail={taskDetail}
                      userPopover="task"
                      userPopoverText="subscribers"
                      mode="edit"
                    >
                      <div className="owner-container-name">
                        {subscribers?.map((l, index) => (
                          <UserItem
                            key={"subscribers-" + index}
                            item={l}
                            notAvatar={true}
                            notTooltip={true}
                          />
                        ))}
                      </div>
                    </UserStatusListPopover>
                    <UserListMore
                      list={handleList(taskDetail.subscribers)}
                      maxLength={4}
                      isShowName={true}
                      hasWeightSet={false}
                      notAvatar={true}
                      title={taskDetail.title}
                      isOwner={isHead}
                      disable={disabled || taskDetail.subscribers?.length >= 200}
                      handleAddTaskMembers={(data: any[]) =>
                        handleAddTaskMembers(MemberKeys.subscribers, data)
                      }
                      userPopover="task"
                      userPopoverText="subscribers"
                      mode="edit"
                      showUserItem={false}
                      taskUserRole={4}
                    />
                  </div>
                </div>
              </div>

              <div className="content-part-other">
                <div className="detail-content-item task-timerange-item common-single-item task-ontime-item">
                  <div className="label">任务时间</div>
                  <div className="timerange-container">
                    {isTaskFinishOrStop || !isPrimaryHead ? (
                      <Tooltip
                        title={
                          isTaskFinishOrStop
                            ? `任务${
                                taskDetail.taskStatus === TASK_STATUS.FINISHED ? "已完成" : "已中止"
                              }不能编辑时间`
                            : "您暂无修改权限"
                        }
                      >
                        <div className="time-button time-button-star">
                          <DatePicker
                            onVisibleChange={onVisibleChange}
                            time={taskDetail.workStartTime || null}
                            onChange={(time: Dayjs | null) => handleTimeChange(time)}
                            disable={isTaskFinishOrStop || !isPrimaryHead}
                            placeholder={t("no start time")}
                            defaultTime={getDefaultStartTime()}
                            isChangeHeaderVisible={true}
                          />
                        </div>
                      </Tooltip>
                    ) : (
                      <div className="time-button time-button-star">
                        <DatePicker
                          onVisibleChange={onVisibleChange}
                          time={taskDetail.workStartTime || null}
                          onChange={(time: Dayjs | null) => handleTimeChange(time)}
                          disable={isTaskFinishOrStop || !isPrimaryHead}
                          placeholder={t("no start time")}
                          defaultTime={getDefaultStartTime()}
                          isChangeHeaderVisible={true}
                        />
                      </div>
                    )}

                    <div className="button-split" />
                    {isTaskFinishOrStop || !isPrimaryHead ? (
                      <Tooltip
                        title={
                          isTaskFinishOrStop
                            ? `任务${
                                taskDetail.taskStatus === TASK_STATUS.FINISHED ? "已完成" : "已中止"
                              }不能编辑时间`
                            : "您暂无修改权限"
                        }
                      >
                        <div className="time-button time-button-end">
                          <DatePicker
                            time={taskDetail.workStopTime || null}
                            onChange={(time: Dayjs | null) => handleTimeChange(time, false)}
                            disable={isTaskFinishOrStop || !isPrimaryHead}
                            placeholder={t("no end time")}
                            defaultTime={getDefaultStopTime()}
                          />
                        </div>
                      </Tooltip>
                    ) : (
                      <div className="time-button time-button-end">
                        <DatePicker
                          time={taskDetail.workStopTime || null}
                          onChange={(time: Dayjs | null) => handleTimeChange(time, false)}
                          disable={isTaskFinishOrStop || !isPrimaryHead}
                          placeholder={t("no end time")}
                          defaultTime={getDefaultStopTime()}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="detail-content-item task-types-item">
                  <div className="label">重要程度</div>
                  <TypeSelect
                    disable={isTaskFinishOrStop || !isPrimaryHead}
                    priority={taskDetail.priorityType ? taskDetail.priorityType : -1}
                    onRadioChange={handlePriorityChange}
                    type="radio"
                    hide={isTaskFinishOrStop || !isPrimaryHead ? true : false}
                    isCreate={true}
                  />
                </div>
                <div className="detail-content-item task-remind-item common-single-item">
                  <div className="label">逾期提醒</div>
                  {isTaskFinishOrStop ||
                  !isPrimaryHead ||
                  !taskDetail.endTime ||
                  taskDetail.endTime === -1 ? (
                    <div>不提醒</div>
                  ) : (
                    <Select
                      disabled={
                        isTaskFinishOrStop ||
                        !isPrimaryHead ||
                        !taskDetail.endTime ||
                        taskDetail.endTime === -1
                      }
                      mode="multiple"
                      allowClear={false}
                      size="small"
                      showArrow={false}
                      showSearch={false}
                      value={remindArr}
                      placeholder={
                        isTaskFinishOrStop || !isPrimaryHead ? "暂无提醒时间" : "请选择提醒时间"
                      }
                      className="timerange-container"
                      onChange={handleTaskReminChange}
                    >
                      {remindList.map((item: any) => {
                        return (
                          <Option
                            key={item.value}
                            value={item.value}
                            style={{
                              display:
                                item.value === "-5" || item.value === "-10" || item.value === "-15"
                                  ? "none"
                                  : "flex"
                            }}
                          >
                            {item.label}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                </div>
                {/* <div className="detail-content-item task-textarea-item">
                  <div className="label" style={{ alignSelf: "flex-start" }}>
                    {t("task description")}
                  </div>
                  <div
                    className={`textarea-container ${
                      textareaContentFocus && (descIsEdit || isPrimaryHead)
                        ? "textarea-container-focus"
                        : ""
                    }`}
                  >
                    <Input.TextArea
                      className={`cursor-outline ${
                        taskDetail.content && taskDetail.content.length > 40
                          ? "padding-bottom-20"
                          : ""
                      }`}
                      placeholder={t("add description")}
                      autoSize
                      disabled={!descIsEdit && !isPrimaryHead}
                      defaultValue={htmlUnescape(taskDetail.content || "")}
                      onChange={(e) => handleInputChange(e, "content")}
                      onFocus={() => setTextareaContentFocus(true)}
                      onBlur={() => setTextareaContentFocus(false)}
                      maxLength={500}
                    />
                    {taskDetail.content && taskDetail.content.length > 40 && (
                      <p className="content-length">
                        <span>{taskDetail.content?.length || 0}</span>/500
                      </p>
                    )}
                  </div>
                </div> */}
              </div>
              <div className="detail-content-item task-group-item">
                <div className="label">任务分组</div>
                <Select
                  className="timerange-container"
                  mode="multiple"
                  onChange={(e) => handleInputChange(e, "taskGroupIds", true)}
                  onDropdownVisibleChange={() => {
                    if (!taskGroupList.length) {
                      fetchTaskGroupsList();
                    }
                  }}
                  showSearch={false}
                  allowClear={false}
                  placeholder="待分组"
                  notFoundContent="暂无分组"
                  size="small"
                  value={
                    taskDetail?.taskGroupIds ||
                    taskDetail?.taskGroups?.map((task) => task.groupId) ||
                    []
                  }
                  bordered={false}
                  showArrow={false}
                  disabled={!isTaskFinishOrStop && isPrimaryHead ? false : true}
                  dropdownClassName="create-taskgroup"
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <span className="create-taskgroup-btn" onClick={() => createTaskgroup()}>
                        +新建任务组
                      </span>
                    </>
                  )}
                >
                  {(taskGroupList || [])
                    .filter((v) => v.groupStatus !== 2)
                    .map((v) => (
                      <Option
                        key={v.groupId}
                        value={v.groupId}
                        style={{
                          display: v.noShow ? "none" : "flex"
                        }}
                      >
                        {v.groupName}
                      </Option>
                    ))}
                </Select>
              </div>
              <div className="detail-content-item task-textarea-item task-mynote-item">
                <div className="label" style={{ alignSelf: "flex-start" }}>
                  {t("my note")}
                </div>
                <div className="textarea-container" style={{ margin: 0, border: "none" }}>
                  <Input.TextArea
                    className="cursor-outline"
                    placeholder="请输入(仅自己可见)"
                    style={{ padding: "4px 0" }}
                    autoSize
                    defaultValue={htmlUnescape((taskDetail.remark as RemarkInfo).remark)}
                    onChange={(e) => handleInputChange(e, "remark")}
                    onFocus={() => setTextareaRemarkFocus(true)}
                    maxLength={500}
                  />
                </div>
              </div>
              <AttachmentItem
                disabled={disabled}
                mode="modify"
                task={true}
                businessForm={BusinessForm.TASK}
                uploaderProxy={true}
                multiple={true}
                fileList={handleList(newFileList)}
                onAttachmentRemove={onAttachmentRemove}
                onAttachmentUploadFinish={onAttachmentUploadFinish}
                uploadControlName="task-edit-upload-panel"
              />
              <div className="detail-content-item task-approval-item">
                <div className="label">审批设置</div>
                <Switch
                  disabled={!isTaskFinishOrStop && isPrimaryHead ? false : true}
                  defaultChecked={taskDetail.processAuditFlag === 0 ? false : true}
                  onChange={(e) => {
                    setTaskDetail({ ...taskDetail, processAuditFlag: e === true ? 1 : 0 });
                  }}
                />
                <Tooltip title={t("Approval settings tip")}>
                  <IconFont type="iconic_app_add_help" />
                </Tooltip>
              </div>
            </div>
          </ScrollView>
          {isModalVisible && (
            <TaskGroupModal userData={userData} setIsModalVisible={setIsModalVisible} />
          )}
        </>
      )}
    </Drawer>
  );
}
function mapStateToProps({ work, user, chat }: any) {
  const { detailState } = work;
  return {
    detailStateActiveTab: detailState.activeTab,
    userData: user.userData.user,
    drawEditVisible: detailState.drawEditVisible,
    taskId: detailState.taskId,
    taskDetail0: detailState.taskDetail,
    forceGet: detailState.forceGet,
    offset: work.offset,
    offsets: work.offsets,
    processStatuses: work.processStatuses,
    taskStatuses: work.taskStatuses,
    priorityTypes: work.priorityTypes,
    userRole: work.userRole,
    fieldSortType: work.fieldSortType,
    taskGroupList: work.taskGroupList,
    groupId: work.groupId,
    activeKey: work.activeKey,
    currentEmployee: chat.currentEmployee || {}
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changeEditTaskDraw: (taskId: string, visible: boolean) =>
      dispatch({
        type: "work/changeEditTaskDraw",
        payload: { taskId, drawEditVisible: visible }
      }),
    openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => {
      dispatch({
        type: "supervise/setCreateModalVisible",
        payload: opt
      });
    },
    getTasks(payload: TaskListParams) {
      return dispatch({
        type: "work/fetchTaskList",
        payload
      });
    },
    getTasksByTaskGroup(payload: TaskListByTaskGroupParams) {
      return dispatch({
        type: "work/fetchTaskListByTaskGroup",
        payload
      });
    },
    fetchTaskGroupsList() {
      return dispatch({
        type: "work/queryTaskGroupsList"
      });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(TaskDetailDrawEdit);
